import { PlatformAppsApiClient } from '@fourthwall/services/dist/PlatformAppsApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'
import { useQueryClient } from '@tanstack/react-query'

const useUpdatePlatformAppSectionMutation = createMutationHook(
  PlatformAppsApiClient.updatePlatformAppClientSection,
  {
    mutationKey: ['updatePlatformAppSection'],
  },
)

export const useUpdatePlatformAppSection = () => {
  const queryClient = useQueryClient()
  const { updatePlatformAppSectionMutation } = useUpdatePlatformAppSectionMutation({
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['platformAppClient'] })
      queryClient.invalidateQueries({ queryKey: ['platformAppClients'] })
    },
  })

  return {
    updatePlatformAppSection: updatePlatformAppSectionMutation.mutate,
    isLoading: updatePlatformAppSectionMutation.isLoading,
  }
}
